import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Icon from '../../components/dashboard/DashboardIcons';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });

export default function ParentInvitePage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState('');
  const [redeemed, setRedeemed] = useState(false);
  const [loading, setLoading] = useState(true);
  const isLoggedIn = !!localStorage.getItem('token');
  const isParent = JSON.parse(localStorage.getItem('user') || '{}')?.role === 'parent';

  useEffect(() => {
    axios.get(`${API}/parent/invite/${token}`).then((res) => setInfo(res.data)).catch((err) => setError(err?.response?.data?.detail || 'رابط الدعوة غير صالح')).finally(() => setLoading(false));
  }, [token]);

  const redeem = async () => {
    try {
      await axios.post(`${API}/parent/invite/${token}/redeem`, {}, auth());
      setRedeemed(true);
      setTimeout(() => navigate('/parent'), 1500);
    } catch (err) {
      setError(err?.response?.data?.detail || 'فشل استخدام رابط الدعوة');
    }
  };

  const goAuth = (path) => {
    localStorage.setItem('pending_parent_invite', token);
    navigate(path);
  };

  return (
    <div dir="rtl" className="flex min-h-screen items-center justify-center bg-[#f4f6fa] p-4" data-testid="parent-invite-page">
      <div className="w-full max-w-sm rounded-2xl bg-white p-8 text-center shadow-lg">
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-2xl bg-teal-50 text-teal-600"><Icon name="users" className="h-7 w-7" /></div>
        {loading ? (
          <p className="mt-4 text-sm text-slate-400">جارٍ التحقق من الدعوة...</p>
        ) : error ? (
          <p className="mt-4 text-sm text-red-600" data-testid="parent-invite-error">{error}</p>
        ) : redeemed ? (
          <p className="mt-4 text-sm font-bold text-teal-700" data-testid="parent-invite-success">تم الربط بنجاح! جارٍ تحويلك...</p>
        ) : (
          <>
            <h2 className="mt-4 text-lg font-bold text-slate-800">دعوة ربط من {info?.club_name}</h2>
            <p className="mt-2 text-sm text-slate-500">استخدم هذه الدعوة لربط ابنك بحسابك في بوابة ولي الأمر فوراً</p>
            {isLoggedIn && isParent ? (
              <button onClick={redeem} data-testid="parent-invite-redeem-btn" className="mt-6 w-full rounded-xl bg-teal-600 py-3 text-sm font-bold text-white hover:bg-teal-700">تأكيد الربط الآن</button>
            ) : (
              <div className="mt-6 space-y-2">
                <button onClick={() => goAuth('/login')} data-testid="parent-invite-login-btn" className="w-full rounded-xl bg-teal-600 py-3 text-sm font-bold text-white hover:bg-teal-700">تسجيل الدخول</button>
                <button onClick={() => goAuth('/register?type=parent')} data-testid="parent-invite-register-btn" className="w-full rounded-xl border border-slate-200 py-3 text-sm font-bold text-slate-600 hover:border-teal-300">إنشاء حساب ولي أمر جديد</button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
